export default Object.freeze({
  info: {},
  sso: {},
});
